export default [
  {
    charset: 'utf-8'
  },
  {
    'http-equiv': 'Cache-Control',
    content: 'no-cache, no-store, must-revalidate'
  },
  {
    'http-equiv': 'Pragma',
    content: 'no-cache'
  },
  {
    'http-equiv': 'Expires',
    content: '0'
  },
  {
    'http-equiv': 'X-UA-Compatible',
    content: 'IE=edge'
  },
  {
    name: 'robots',
    content: 'index,follow'
  }
]
